import { useState, useContext, useEffect } from 'react';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import ChartFromServer from '../../../Components/Charts/ChartFromServer';
import ButtonsList from '../../../Components/Buttons/ButtonsList';
import './Dashboard.css';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import * as Utilities from '../../../Components/Utils/Utils';


export default function AnalisisVentas({ idLocatario }) {

    const token = useGetToken();

    const [año1, setAño1] = useState(new Date());
    let dateFormated1 = año1.getFullYear();

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [año2, setAño2] = useState(new Date(year - 1, month, day));
    let dateFormated2 = año2.getFullYear();

    const [año3, setAño3] = useState(new Date());
    let dateFormated3 = año3.getFullYear();

    registerLocale("es", es);

    const colorList = [
        "#4472C4",
        "#4472C4",
        "#F64E60",
        "#F64E60"
    ];
    const settings = {
        "disableTooltipX": false,
        "disableTooltipY": false,
        "disableLabelX": false,
        "disableLabelY": false,
        "tooltipDy": 0,
        "tooltipAft": "",
        "enableBullet": true,
        "circleBulletRadius": 5,
        "enableLegend": true,
        "widthColumn": 1,
        "strokeWidth": 2,
        "timeTotalAnimation": 20,
        "exportar": true,
        "titleYizq": "",
        "titleYder": "",
        "labelAdapterAxisYIzq": "",
        "labelAdapterAxisYDer": "",
        "periodChange": "MMM",
        "inputDateFormat": "dd/MM/yyyy"
    }

    const dataSeries = [
        {
            "name": "Venta " + dateFormated1,
            "field": "ventaAnio1",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        },
        {
            "name": "Venta " + dateFormated2,
            "field": "ventaAnio2",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        }
    ];

    const dataSeries2 = [
        {
            "name": "Venta Prom. Rubro " + dateFormated3,
            "field": "ventaPromedioRubro",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        },
        {
            "name": "Venta " + dateFormated3,
            "field": "ventaAnio",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        }
    ];



    return (
        <>
            <div className="card mb-5 mb-xl-8">

                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder fs-3 mb-1">Ventas Totales</span>
                        <span className="text-muted fw-bold fs-7">Por Mes</span>
                    </h3>
                    <div className="card-toolbar" >
                        <div className='p-2'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Reporte:</div>
                            <DatePicker
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={año1}
                                onChange={(dateX) => dateX && setAño1(dateX)}
                                dateFormat="yyyy"
                                showYearPicker
                                minDate={Utilities.add_years(new Date(), -6)}
                                maxDate={new Date()}
                            />
                        </div>
                        <div className='p-2'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                            <DatePicker
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={año2}
                                onChange={(dateX) => dateX && setAño2(dateX)}
                                dateFormat="yyyy"
                                showYearPicker
                                minDate={Utilities.add_years(new Date(), -6)}
                                maxDate={new Date()}
                            />
                        </div>
                    </div>
                </div>


                <div className="card-body py-3">
                    <ChartFromServer
                        setAuxData={null}
                        apiService={Api.DashboardVentasTotalesxMes}
                        args={{ idLocatario: idLocatario, anio1: dateFormated1, anio2: dateFormated2, token: token }}
                        conditions={true}
                        type="LinealMultiAxis"
                        idContent={"VentasToatalesxMes_chart" + dateFormated1 + dateFormated2}
                        dataSeries={dataSeries}
                        colorList={colorList}
                        settings={settings}
                        classContent="chart400Height"
                        setEnableQuery={null}
                    >
                    </ChartFromServer>

                </div>
            </div>


            <div className="card mb-5 mb-xl-8">

                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder fs-3 mb-1">Promedio de Rubro por Mes</span>
                        <span className="text-muted fw-bold fs-7">VS Ventas Totales</span>
                    </h3>
                    <div className="card-toolbar" >
                        <div className='p-2'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Reporte:</div>
                            <DatePicker
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={año3}
                                onChange={(dateX) => dateX && setAño3(dateX)}
                                dateFormat="yyyy"
                                showYearPicker
                                minDate={Utilities.add_years(new Date(), -6)}
                                maxDate={new Date()}
                            />
                        </div>
                    </div>
                </div>


                <div className="card-body py-3">
                    <ChartFromServer
                        setAuxData={null}
                        apiService={Api.DashboardPromedioRubroXMesVsTotales}
                        args={{ idLocatario: idLocatario, anio: dateFormated3, token: token }}
                        conditions={true}
                        type="LinealMultiAxis"
                        idContent={"PromedioRubroXMesVsTotales" + dateFormated3}
                        dataSeries={dataSeries2}
                        colorList={colorList}
                        settings={settings}
                        classContent="chart400Height"
                        setEnableQuery={null}
                    >
                    </ChartFromServer>

                </div>
            </div>
        </>
    )
}
